export default "__VITE_ASSET__2ac92725__"